// extracted by mini-css-extract-plugin
module.exports = {"nopadding":"Leaflet_nopadding__ybA5m"};